module.exports = __webpack_public_path__ + "static/media/folder_room_02.0a7c779d.png";